import { Link } from '@nextui-org/react'
import { motion } from 'framer-motion'

import { LittleText, Text } from '@/components/common/UI'
import { Icons } from '@/components/icons'
interface TipsProps {
    title?: string
    text: string
    url?: string
    className?: string
    banner?: 'news' | 'tips'
}
export const Tips = ({
    text,
    title = 'Tips',
    url,
    className,
    banner = 'tips'
}: TipsProps): JSX.Element => {
    return (
        <motion.article
            className={`max-w-80 md:max-w-full p-4 space-y-2 rounded-xl ${banner === 'tips' ? 'bg-yellow-100' : 'bg-green-100'} ${className}`}
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
        >
            <div className="flex items-center text-center gap-2">
                {banner === 'tips' ? (
                    <Icons.Light className="text-yellow-400" />
                ) : (
                    <Icons.News />
                )}
                <Text
                    text={title}
                    className="font-bold uppercase"
                />
            </div>
            <LittleText text={text} />
            {url && (
                <div className="w-full">
                    <Link
                        href={url}
                        isExternal
                        showAnchorIcon
                        underline="always"
                        size="sm"
                        className="text-xs"
                    >
                        {url}
                    </Link>
                </div>
            )}
        </motion.article>
    )
}
